import DocumentIllustration from "components/DocumentIllustration";
import { useContext, useEffect, useState } from "react";
import IDTrackerPricing from "features/breaches/pages/IDTrackerPricing";
import VerifyDarkWebDocument from "features/darkweb/components/VerifyDarkWebDocument";
import { ReactComponent as IconDarkWeb } from "assets/img/icons/icon_Thief.svg";
import logoExpert from "assets/img/VerificationExperts.svg";
import './DWAnalysisResults.scss';
import Alert from "shared/ui/Alert";
import { ReactComponent as IconChecked } from "assets/img/icons/icon_status-Checked.svg";
import { ReactComponent as IconInfo } from "assets/img/icons/icon_Info.svg";
import { ReactComponent as IconWarning } from "assets/img/icons/icon_status-Warning.svg";

import Footer from "components/Footer";
import { UserContext } from "features/account";
import Modal from "shared/ui/Modal";

const iconProps = {
    fill: "#272f91",
    width: "24px",
};


export default function DWAnalysisResults() {
    const [type, setType] = useState<string>("");
    const [verificationDone, setVerificationDone] = useState<boolean>(false);
    const [verificationResult, setVerificationResult] = useState<any>(null);
    const [documentNumber, setDocumentNumber] = useState<any>(null);
    const [documentType, setDocumentType] = useState<any>(null);
    const [documentCountry, setDocumentCountry] = useState<any>(null);
    const { userType } = useContext(UserContext);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [secondsLeft, setSecondsLeft] = useState(10);
    
    const handleChangeType = (type: string) => {
        setType(type);
    };

    const handleVerificationResult = (result: any) => {
        setVerificationResult(result);
        console.log("verification result", result);
        setVerificationDone(true);
    };

    const handleVerificationDone = (done: boolean) => {
        setVerificationDone(done);
        console.log("verification done", done);
        if (done) {
            setShowModal(true);
            setSecondsLeft(10);
        }
    };

    const handledocumentinfos = (number: string, type:string, country: string) => { 
        setDocumentNumber(number);
        setDocumentType(type);
        setDocumentCountry(country);
        console.log("document infos", number, type, country);
    }

    const refresh = () => {
        setVerificationResult(undefined);
        setVerificationDone(false);
    };

    const handleCloseModal = () => {
        setShowModal(!showModal);
    };

        // Countdown logic
        useEffect(() => {
            if (showModal && secondsLeft > 0) {
            const countdown = setInterval(() => {
                setSecondsLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(countdown);
            } else if (secondsLeft === 0) {
            setShowModal(false);
            }
        }, [showModal, secondsLeft]);

        const renderTime = () => {
            return (
              <div className="flex justify-content-center align-items-center">
                <div className="value">{secondsLeft}</div>
              </div>
            );
          };
    return (
        <div className="content">
            <div className="content__header">
                <div className="content__header__title">
                    <IconDarkWeb {...iconProps} />
                    <h4>Dark Web</h4>
                </div>
            </div>

            <div className="content__header__body ">
                {!verificationDone && (<div className="row h-100 align-items-center">
                    <div className='col-sm-6 p-2 h-100'>
                        <div className="card h-100 ">
                            <VerifyDarkWebDocument
                                type={type}
                                setdocumentinfos={handledocumentinfos}
                                setType={handleChangeType}
                                setVerificationDone={handleVerificationDone}
                                verificationDone={verificationDone}
                                setVerificationResult={handleVerificationResult}
                            />
                        </div>  
                    </div>
                    <div className='col-sm-6 d-flex justify-content-center align-items-center'>
                        <DocumentIllustration type={type} />
                    </div>
                    <Footer />
                </div>)}

                {verificationDone && (
                    
                    <>{showModal && (<Modal
                        isOpen={true}
                        onClose={handleCloseModal}
                        title=""
                        type="info"
                        infoModal={true}
                        hasTimer={true}
                        timer={secondsLeft}
                        > <IconInfo
                        fill="#1956A8"
                        width="100%"
                        height="6rem"
                         />
                        <span className="text-center flex-column d-flex justify-content-center align-items-center">
                            L'analyse est terminée ! Vous pouvez fermer cette fenêtre.
                            <br/>
                            {secondsLeft >1 && (<div>
                                Fermeture automatique dans <span className="text-grey">{secondsLeft} secondes</span>.
                            </div>)}
                            {secondsLeft == 1 && (<div>
                                Fermeture automatique dans <span className="text-grey">{secondsLeft} seconde</span>.
                            </div>)}
                        </span>
                        {/*<div className="d-flex flex-column justify-content-center align-items-center">
                            <ResizableCircularTimer
                                duration={secondsLeft}
                                size={70}
                                strokeWidth={7}
                                color="#0000ff"
                                bgColor="#f0f0f0"
                                onComplete={() => console.log('Done')}
                                />
                        </div>*/}
                          </Modal>)}
                    
                    <div className="col-sm-6">
                            <div className="card">
                                <div className="content__header">
                                    <div className="content__header__title " id="result">
                                        <div className="content__header__title__left">
                                            <img
                                                src={logoExpert}
                                                alt="" />
                                            <h4>Résultat De l'analyse</h4>
                                        </div>
                                        {verificationResult?.darkWeb ? (
                                            <div className="content__header__title_right">
                                                <div className="d-flex gap-05 align-items-center">
                                                    <IconWarning
                                                        fill="#FF5326"
                                                        width="1.5rem"
                                                        className="flex-none" />
                                                    <h4 style={{ color: "#FF5326" }} className="text-center">Vos données figurent sur le Dark Web</h4>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex gap-05 align-items-center">
                                                <IconChecked
                                                    fill="#17EB79"
                                                    width="1.5rem"
                                                    className="flex-none" />
                                                <h4 style={{ color: "#17EB79" }} className="text-center">Vos données ne figurent pas sur le Dark Web</h4>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="h-100">
                                    <div className="d-flex flex-column align-items-start justify-content-start p-2">
                                        {documentType == "passport" && <h3>Passeport</h3>}
                                        {documentType == "id" && <h3>Carte d'identité</h3>}
                                        {documentType == "residency_permit" && <h3>Carte de Séjour</h3>}
                                        {documentType == "driver_permit" && <h3>Permis de Conduire</h3>}
                                        <p>{documentNumber}</p>
                                    </div>
                                    {verificationResult?.darkWeb && userType === 'partner' && (
                                        <Alert type="error">Soyez vigilant</Alert>
                                    )}

                                        <Alert type="info">
                                            <b>Vos données personnelles sur le Dark Web ?</b>
                                            <br />
                                            ID Tracker vous alerte dès qu’un document vous concernant y est détecté. Activez la surveillance dès maintenant.
                                        </Alert>
                                </div>

                            </div>
                        <IDTrackerPricing isPage={false} isOuSide={true}/>
                        </div>

                    </>
                )}
            </div>

        </div>
    )
}
